import {
  Avatar,
  Button,
  Divider,
  Menu,
  message,
  Modal,
  Typography,
  Upload,
} from "antd";
import ProfileAvatar from "assets/images/profile-avatar.png";
import InitialAvatar from "common/components/Initials/InitialAvatar";
import User from "models/user/user";
import NetworkCall from "network/networkCall";
import Request from "network/request";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Webcam from "react-webcam";
import { saveUserProfile, userProfile } from "redux/user/userSlice";
import { getInitials } from "utilities/generalUtility";

const { Title, Link } = Typography;

export default function ProfileModal({
  isModalOpen,
  setIsModalOpen,
  firstName,
  lastName,
}) {
  const videoElement = useRef(null);
  const dispatch = useDispatch();
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [pictureView, setPictureView] = useState({
    webcam: false,
    uploadProfile: true,
    selectedKey: "a",
  });
  const [imageURL, setImageURL] = useState();
  const [imageFile, setImageFile] = useState();
  const [isLoading, setIsloading] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [webProfileImage, setWebProfileImage] = useState();
  const [captureBtn, setCaptureBtn] = useState(true);
  const [remove, setRemove] = useState(false);
  // const userProfileImage = useSelector(userProfile);

  const getBase64 = async (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => resolve(reader.result);

      reader.onerror = (error) => reject(error);
    });
  useEffect(() => {
    setProfileImage(User.getProfilePicture());
  }, []);
  const props = {
    name: "file",
    action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
    headers: {
      authorization: "authorization-text",
    },
    onChange(info) {
      // const { status } = info?.file;
      setImageFile(info?.file);
      if (info.file.status !== "uploading") {
      }
      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    beforeUpload(info) {
      getBase64(info).then(function (value) {
        // setImageURL(value);
        setProfileImage(value);
      });

      return false;
    },
  };
  // const profileImage = User.getProfilePicture();
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsloading(true);
    pictureView.selectedKey === "a"
      ? uploadProfileImg(imageFile)
      : pictureView.selectedKey === "b"
      ? webCamImage()
      : removeImage();
  };
  const handleCancel = () => {
    setCaptureBtn && stopCam();
    setImageURL();
    setWebProfileImage();
    setCaptureBtn(true);
    setProfileImage(User.getProfilePicture());
    setPictureView((prev) => {
      return { ...prev, webcam: false, uploadProfile: true, selectedKey: "a" };
    });
    setIsModalOpen(false);
    setRemove(false);
  };
  const stopCam = () => {
    let stream = videoElement?.current?.stream;
    const tracks = stream?.getTracks();
    tracks?.forEach((track) => track.stop());
  };
  const setModalView = (webValue, uploadValue, value) => {
    setPictureView((prev) => {
      return {
        ...prev,
        webcam: webValue,
        uploadProfile: uploadValue,
        selectedKey: value?.key,
      };
    });
  };
  const uploadProfileImg = async (img) => {
    try {
      const formData = new FormData();
      formData.append("image", img);
      const response = await NetworkCall.fetch(
        Request.uploadProfileImage(formData),
        false
      );
      if (response) {
        const getResponse = await User.getUserProfile();
        // dispatch(saveUserProfile(getResponse?.data?.user?.profileImageUrl));
      }
      // message.success(response.message);

      setIsloading(false);
      setIsModalOpen(false);
      pictureView.selectedKey === "b" && stopCam();
      setPictureView((prev) => {
        return {
          ...prev,
          webcam: false,
          uploadProfile: true,
          selectedKey: "a",
        };
      });
      setCaptureBtn(true);
      setWebProfileImage();
    } catch (error) {
      setIsloading(false);

      // setFieldErrorsFromServer(error, form, values);
      error?.error && message.error(error.message);
    }
  };

  const webCamImage = async () => {
    const blob = await fetch(webProfileImage).then((res) => res.blob());

    uploadProfileImg(blob);
  };

  const removeImage = async () => {
    try {
      const response = await NetworkCall.fetch(
        Request.removeProfileImage(),
        false
      );
      if (response) {
        const getResponse = await User.getUserProfile();
        // dispatch(saveUserProfile(getResponse?.data?.user?.profileImageUrl));
      }
      setIsloading(false);
      setIsModalOpen(false);
      pictureView.selectedKey === "b" && stopCam();
      setPictureView((prev) => {
        return {
          ...prev,
          webcam: false,
          uploadProfile: true,
          selectedKey: "a",
        };
      });
      setCaptureBtn(true);
      setWebProfileImage();
      setRemove(true);
    } catch (error) {
      message.error(error.message);
    }
  };

  return (
    <>
      {/* <Button
        type="link"
        onClick={showModal}
        className="modal-open-btn"
        icon={<i className="icon-camera"></i>}
      ></Button> */}
      <Modal
        className="create-diary-modal cm-modal "
        centered
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        closeIcon={<i className="icon-close"></i>}
        footer={[
          <Button
            disabled={pictureView.selectedKey === "b" && captureBtn}
            key="submit"
            type="primary"
            onClick={handleOk}
            loading={isLoading}
          >
            Save Changes
          </Button>,
          <Button ghost key="back" onClick={handleCancel}>
            Cancel
          </Button>,
        ]}
      >
        <div className="common-modal-header">
          <i className="modal-icon icon-camera"></i>
          <Title level={4}>Change your Profile Picture</Title>
        </div>
        <Divider />
        <Menu
          mode="horizontal"
          selectedKeys={pictureView.selectedKey}
          className="profile-menu"
        >
          <Menu.Item
            onClick={(value) => setModalView(false, true, value)}
            key="a"
          >
            Choose File
          </Menu.Item>
          <Menu.Item
            onClick={(value) => setModalView(true, false, value)}
            key="b"
          >
            Take a Picture
          </Menu.Item>
          {profileImage !== "" && (
            <Menu.Item
              onClick={(value) => setModalView(false, false, value)}
              key="c"
            >
              Remove Picture
            </Menu.Item>
          )}
        </Menu>
        {pictureView.webcam ? (
          <>
            <div className="position-relative new-profile take-pic-tab">
              <Avatar
                className="avatar-img"
                size={400}
                src={
                  webProfileImage ? (
                    webProfileImage
                  ) : (
                    <Webcam
                      // size={400}
                      audio={false}
                      ref={videoElement}
                      screenshotFormat="image/jpeg"
                      videoConstraints={{ width: 400, height: 400 }}
                    ></Webcam>
                  )
                }
              />
              <Upload
                showUploadList={false}
                beforeUpload={() => {
                  /* update state here */
                  return false;
                }}
                {...props}
              >
                {/* <Button
                  type="link"
                  // onClick={showModal}
                  className="modal-open-btn"
                  icon={<i className="icon-camera"></i>}
                ></Button> */}
                {/* <Button icon={<UploadOutlined />}>Click to Upload</Button> */}
              </Upload>
              {/* {captureBtn && (
                <button
                  onClick={() => {
                    const imageSrc = videoElement.current.getScreenshot();
                    setWebProfileImage(imageSrc);
                    setCaptureBtn(false);
                    // webCamImage(imageSrc);
                  }}
                >
                  Capture photo
                </button>
              )} */}
            </div>
            <div className="retake-link">
              {captureBtn ? (
                <Link
                  onClick={() => {
                    const imageSrc = videoElement.current.getScreenshot();
                    setWebProfileImage(imageSrc);
                    setCaptureBtn(false);
                    // webCamImage(imageSrc);
                  }}
                >
                  <i className="icon-camera"></i>
                  Take Picture
                </Link>
              ) : (
                <Link
                  onClick={() => {
                    stopCam();
                    setImageURL();
                    setWebProfileImage();
                    setCaptureBtn(true);
                  }}
                >
                  <i className="icon-retake"></i>
                  Retake Picture
                </Link>
              )}
            </div>
          </>
        ) : pictureView.uploadProfile ? (
          <div className="position-relative new-profile choose-file-tab">
            <Avatar
              className="avatar-img"
              size={200}
              src={
                profileImage === "" ? (
                  <InitialAvatar
                    initials={getInitials(firstName, lastName)}
                    check={"200"}
                  />
                ) : (
                  profileImage
                )
              }
            />
            <Upload
              showUploadList={false}
              beforeUpload={() => {
                /* update state here */
                return false;
              }}
              {...props}
            >
              <Button
                type="link"
                // onClick={showModal}
                className="modal-open-btn"
                icon={<i className="icon-camera"></i>}
              ></Button>
              {/* <Button icon={<UploadOutlined />}>Click to Upload</Button> */}
            </Upload>
          </div>
        ) : (
          <div className="avatar-img remove-pic">
            <Link href="#" onClick={() => setRemove(true)}>
              <i class="icon-decline"></i>
            </Link>
            <Avatar
              size={150}
              src={
                remove ? (
                  <InitialAvatar
                    initials={getInitials(firstName, lastName)}
                    check={"150"}
                  />
                ) : (
                  profileImage
                )
              }
            />
          </div>
        )}
      </Modal>
    </>
  );
}
